"use strict";
var HlsJs = require('hls.js/lib');
var types_1 = require("../../types");
var HlsStream = (function () {
    function HlsStream(mediaStreams, emit) {
        var _this = this;
        this.emit = emit;
        this.hls = null;
        this.videoElement = null;
        this.mediaStream = null;
        this.attachOnPlay = function () {
            if (!_this.videoElement) {
                return;
            }
            _this.hls.startLoad();
            _this.videoElement.removeEventListener('play', _this.attachOnPlay);
        };
        this.onManifestParsed = function (eventType, _a) {
            var _b = _a.levels, levels = _b === void 0 ? [] : _b, _c = _a.firstLevel, firstLevel = _c === void 0 ? -1 : _c;
            var mediaLevels = levels.map(function (level) {
                return { bitrate: level.bitrate, width: level.width, height: level.height, name: level.name };
            });
            _this.emit('levels', mediaLevels);
            if (firstLevel >= 0) {
                _this.emit('currentLevel', firstLevel);
            }
        };
        this.onError = function (type, errorEvent) {
            if (errorEvent && (errorEvent.details === 'manifestParsingError' || errorEvent.details === 'manifestLoadError')) {
                _this.emit('error', types_1.Errors.SRC_LOAD_ERROR, _this.mediaStream && _this.mediaStream.url, errorEvent);
            }
        };
        if (mediaStreams.length === 1) {
            this.mediaStream = mediaStreams[0];
        }
        else {
            throw new Error("Vidi can only handle a single HLS stream. Received " + mediaStreams.length + " streams.");
        }
    }
    HlsStream.prototype.attach = function (videoElement, initialBitrate) {
        if (!this.mediaStream) {
            return;
        }
        this.videoElement = videoElement;
        var config = { abrEwmaDefaultEstimate: initialBitrate * 1000 };
        if (videoElement.preload === 'none') {
            config.autoStartLoad = false;
            videoElement.addEventListener('play', this.attachOnPlay);
        }
        this.hls = new HlsJs(config);
        this.hls.on(HlsJs.Events.MANIFEST_PARSED, this.onManifestParsed);
        this.hls.on(HlsJs.Events.ERROR, this.onError);
        this.hls.loadSource(this.mediaStream.url);
        this.hls.attachMedia(videoElement);
    };
    HlsStream.prototype.detach = function (videoElement) {
        if (!this.mediaStream) {
            return;
        }
        this.hls.off(HlsJs.Events.MANIFEST_PARSED, this.onManifestParsed);
        this.hls.off(HlsJs.Events.ERROR, this.onError);
        this.hls.destroy();
        this.hls = null;
        videoElement.removeEventListener('play', this.attachOnPlay);
        this.videoElement = null;
    };
    HlsStream.prototype.getMediaStreamDeliveryType = function () {
        return types_1.MediaStreamDeliveryType.ADAPTIVE_VIA_MSE;
    };
    HlsStream.prototype.setMediaLevel = function (newLevel, videoElement) {
        // TODO
    };
    HlsStream.isSupported = function (env) {
        return env.MSE && HlsJs.isSupported();
    };
    ;
    HlsStream.canPlay = function (mediaType) {
        return mediaType === types_1.MediaStreamTypes.HLS;
    };
    return HlsStream;
}());
exports.HlsStream = HlsStream;
//# sourceMappingURL=hls-stream.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/media-streams/playable-streams/hls-stream.js
// module id = 2766
// module chunks = 66